  <template>
  <div id="wrapper">
    <!-- Sidebar -->
    <SideNav />
    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">
      <!-- Main Content -->
      <div id="content">
        <!-- Topbar -->
        <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
          <!-- Sidebar Toggle (Topbar) -->
          <button id="sidebarToggleTop" class="btn d-md-none rounded-circle mr-3">
            <i class="text-info fa fa-bars"></i>
          </button>

          <button
            href="#"
            class="d-none d-sm-inline-block btn btn-outline-danger shadow-sm"
            style="position:absolute; right:10px"
            @click="logout"
          >Logout</button>
          <p>
            <!-- welcome! {{admin.name}} -->
          </p>
        </nav>
        <!-- End of Topbar -->

        <!-- Begin Page Content -->
        <div class="container-fluid">
          <router-view />
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- End of Main Content -->

      <!-- Footer -->
        <footer class="sticky-footer bg-white">
          <div class="container my-auto">
            <div class="copyright text-center my-auto">
              <p>Copyright &copy; TribeId</p>
              <p>In association with the <span style="color:black; font-weight:bolder"> African Union Open Corridors Initiative</span> </p>
              <p>In partnership with the <span style="color:black; font-weight:bolder">AFCFT Secretariat </span></p>
            </div>
          </div>
      </footer>
      <!-- End of Footer -->
    </div>
    <!-- End of Content Wrapper -->
    <!-- 
      Start modal component
     -->
  </div>
  <!-- End of Page Wrapper -->
</template>

<script>
import SideNav from './SideNav'
import Storage from '@/helpers/storage.js'

export default {
  name:'adminDashboard',
  components: {
    SideNav:SideNav
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
        .then( ()=> this.$router.push('/admin/login'))
    }
  },
  computed:{
    admin() {
      return JSON.parse(localStorage.getItem('admin'))
    }
  },
  created(){
    console.log('admin from component', this.admin)
  }
}
</script>

<style>
  #accordionSidebar{
    background-color: #ba2428;
  }
</style>